const img = "_uxsi1ir5l31";
const link = "_uxslwj7cb3";
const boxWrapper = "_uxsb1ncgl0l";
const richtextStyles = "_uxsrh7u6i2";

export { boxWrapper, img, link, richtextStyles };
import "./molecule.context.style.linaria.module.css";
//# sourceMappingURL=molecule.context.style.js.map
